import * as React from "react";
import cn from "classnames";

const styles = require("./style.less");

interface DataTableHeaderProps {
    className?: string;
}

export class DataTableHeader extends React.Component<DataTableHeaderProps> {
    render() {
        return <thead className={cn(this.props.className, styles.dataTableHeader)}>{this.props.children}</thead>;
    }
}
